import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import { useTranslation } from "react-i18next";

// import { LineChart } from "@tremor/react";
// import ExportToCsv from "./ExportDataIntoExcel";

// export function LineChartHero({ getDRDTooltip, chartData = {} }) {
//   const { data, title, categories, excelData } = chartData;
//   console.log(data, categories, categories.reduce((acc, curr) => {
//     acc.push({
//       label: curr,
//       data: data.map(d => d[curr])
//     })
//     return acc;
//   }, []))
//   return (
//     <>
//       <div className="flex gap-3 items-center">
//         {getDRDTooltip("drd-line-chart", "Drag and drop")}
//         {/* <ExportToCsv jsonData={excelData} filename={"AreChartData.csv"} /> */}
//       </div>
//       <LineChart
//         className="h-80"
//         data={data}
//         index="date"
//         categories={categories}
//         yAxisWidth={60}
//         onValueChange={(v) => console.log(v)}
//         showLegend={false}
//       />
//     </>
//   );
// }

// export default LineChartHero;

export default function LineStylesDemo({
  getDRDTooltip,
  chartData: propChartData = {},
}) {
  const { data, title, categories, excelData } = propChartData;
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

    const chartInfo = {
      labels: data.map((d) => d.date),
      datasets: categories.reduce((acc, curr) => {
        acc.push({
          label: curr,
          data: data.map((d) => d[curr]),
          borderColor: documentStyle.getPropertyValue("--pink-500"),
        });
        return acc;
      }, []),
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          display: false,
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          grid: {
            color: surfaceBorder,
          },
        },
        y: {
          grid: {
            color: surfaceBorder,
          },
        },
      },
    };

    setChartData(chartInfo);
    setChartOptions(options);
  }, []);
  const { t } = useTranslation();
  return (
    <>
      <div className="flex gap-3 align-items-center">
        {getDRDTooltip("drd-line-chart", t("DRAG_AND_DROP"))}
      </div>
      <div className="mx-auto space-y-12">
        <div className="flex flex-column" style={{ gap: "10px" }}>
          <label className="font-bold flex justify-content-center">
            {title}
          </label>
          <div className="flex justify-center flex-column">
            <Chart type="line" data={chartData} options={chartOptions} />
          </div>
        </div>
      </div>
    </>
  );
}
